const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3000/api";

export async function api<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    if (response.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    throw new Error(
      payload.error || payload.message || "Une erreur est survenue."
    );
  }
  if (response.status === 204) return undefined as unknown as T;
  return response.json();
}

export { API_URL };
